import { iconBodies } from "@rally/ui-kit/src/components/icon-paths.ts";

type Glyph = keyof typeof iconBodies;

const CATEGORIES: readonly { words: readonly string[]; glyph: Glyph }[] = [
  { words: ["reaction", "reactions", "reacting", "emoji", "emojis"], glyph: "thumbs-up" },
  { words: ["search", "omnisearch", "recherche", "recherches", "chercher"], glyph: "search" },
  { words: ["bio", "biography", "biographie", "profile", "profiles", "profil", "profils"], glyph: "user" },
  { words: ["table", "tables", "tableau", "tableaux"], glyph: "grid" },
  { words: ["markdown"], glyph: "file-text" },
  { words: ["navigation", "sidebar", "menu", "menus", "naviguer"], glyph: "compass" },
  { words: ["image", "images", "photo", "photos", "picture", "pictures"], glyph: "image" },
  {
    words: ["icon", "icons", "icone", "icones", "pictogram", "pictograms", "pictogramme", "pictogrammes"],
    glyph: "shapes",
  },
  {
    words: ["sport", "sports", "football", "soccer", "basketball", "tennis", "rugby", "hockey"],
    glyph: "trophy",
  },
];

export function conversationGlyph(icon: string | null, title: string | null): Glyph {
  if (icon) return Object.hasOwn(iconBodies, icon) ? (icon as Glyph) : "message-square";
  const words = new Set(
    (title ?? "")
      .normalize("NFD")
      .replace(/\p{M}/gu, "")
      .toLowerCase()
      .split(/[^\p{L}\p{N}]+/u),
  );
  return (
    CATEGORIES.find((category) => category.words.some((word) => words.has(word)))?.glyph ?? "message-square"
  );
}
